<template>
<div class="chapter">
<div class="inner_page">
<p class="also"><a id="page_ii">Also by Kyle Ward</a></p><a id="page_ii">
<p class="also1"><em class="italic">History Lessons: How Textbooks from Around the World Portray U.S. History</em> (with Dana Lindaman)</p>
<p class="also2"><em class="italic">In the Shadow of Glory: The Thirteenth Minnesota in the Spanish-American and Philippine-American Wars, 1898–1899</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Also.vue?0459f814